import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StickyBody from '../../../../shared-components/StickyBody/StickyBody';
import StickyFooter from '../../../../shared-components/StickyFooter/StickyFooter';
import Button, { BUTTON_TYPE } from '../../../../shared-components/Button/Button';
import { FormattedHTMLMessage, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import CancelUrl, { COMPONENT_STYLE } from '../../../components/CancelUrl/CancelUrl';
import { Form, getFormValues, reduxForm, submit } from 'redux-form';
import { CYCO_FORM_ID } from '../../../../framework/App/AppConstants';
import { submitCycoApiAction } from './CycoPageActions';
import NotificationBanner, { NOTIFICATION_TYPE } from '../../../../shared-components/NotificationBanner/NotificationBanner';
import OfferTileGroup from '../../../../shared-components/OfferTileGroup/OfferTileGroup';
import PopupLink from '../../../../shared-components/PopupLink/PopupLink';
import _ from 'lodash';
import StickyContainer from '../../../../shared-components/StickyContainer/StickyContainer';
import { spinnerOpen } from '../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import { scrollToTop } from '../../../../framework/App/SkeletonPage/SkeletonPageActions';

const LOCALE_PREFIX = 'DE/pages/CycoPage/CycoPage';

export class CycoPageForm extends Component {
    static propTypes = {
        onClickContinue: PropTypes.func.isRequired,
        mppInstallmentsTermsUrl: PropTypes.string.isRequired,
        serverValidationErrors: PropTypes.string,

        // Comes from injectIntl HOC
        intl: intlShape.isRequired,

        // Provided from decorated reduxForm() component
        handleSubmit: PropTypes.func.isRequired,

        onFormSubmit: PropTypes.func.isRequired,
        formValues: PropTypes.object.isRequired,
        submitFailed: PropTypes.bool.isRequired
    };

    cycoPageContent = (mppInstallmentsTermsUrl) => {
        const { intl, formValues, submitFailed, serverValidationErrors } = this.props;
        const showMustChooseOfferError = (submitFailed || serverValidationErrors) && _.isEmpty(formValues.offer);

        return (
            <React.Fragment>
                <div className="vx_text-3 cycoTitle">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cyco-page-title-acq`} />
                </div>
                <div className="vx_text-3_lighter cycoTitleDesc">
                    <FormattedMessage id={`${LOCALE_PREFIX}.cyco-page-description`} />
                </div>
                {showMustChooseOfferError && (
                    <NotificationBanner
                        id="mustChooseOfferError"
                        message={intl.formatMessage({id: `${LOCALE_PREFIX}.cyco-page-must-choose-offer-error`})}
                        type={NOTIFICATION_TYPE.ERROR_FILL}
                        className="validationError"
                    />
                )}
                <div className="cycoOffersContent">
                    <OfferTileGroup localePrefix={LOCALE_PREFIX} />
                    <div className="cycoTerms">
                        <p className="cycoPage-stca cycoPage-stca--ni">
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cyco-page-terms-and-conditions`}>
                                {txt => <span>{txt} </span>}
                            </FormattedHTMLMessage>
                            <PopupLink className="cycoSeeTermsLink" url={mppInstallmentsTermsUrl}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.cyco-page-see-terms-link`} />
                            </PopupLink>
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    handleSubmit = event => {
        event.preventDefault();
        this.props.onClickContinue();
    };

    render() {
        const {mppInstallmentsTermsUrl, handleSubmit, onFormSubmit} = this.props;
        return (
            <Form
                id="cyco-form"
                onSubmit={handleSubmit(onFormSubmit)}
            >
                <StickyContainer>
                    <StickyBody>
                        <div className="cyco-offers">
                            {this.cycoPageContent(mppInstallmentsTermsUrl)}
                        </div>
                    </StickyBody>
                    <StickyFooter fixToBottom={false} fadedBackground={true}>
                        <div id="action-buttons" className="vx_btn-group">
                            <Button
                                data-automation-id="continue"
                                className="vx_btn vx_btn-block"
                                btnType={BUTTON_TYPE.SUBMIT}
                            >
                                <FormattedMessage id={`${LOCALE_PREFIX}.cyco-page-continue-btn-acq`} />
                            </Button>
                            <CancelUrl
                                componentType={COMPONENT_STYLE.LINK_BUTTON}
                                fptiEvent={{
                                    stateName: 'pp_credit_cycopage',
                                    transitionName: 'cancel_pp_credit_cycopage'
                                }}
                                customCancelLinkMessage={`${LOCALE_PREFIX}.cyco-page-custom-cancel-link`}
                            />
                        </div>
                    </StickyFooter>
                </StickyContainer>
            </Form>
        );
    }
}

export const validate = (values) => {
    const errors = {};

    if (!values.offer){
        errors.offer = 'Required';
    }

    return errors;
};

export const onSubmitFail = (errors, dispatch) => {
    dispatch(scrollToTop());
};

export const mapStateToProps = state => ({
    formValues : getFormValues(CYCO_FORM_ID)(state) || {},
    mppInstallmentsTermsUrl: _.get(state, 'serverData.mppInstallmentsTermsUrl', ''),
    serverValidationErrors: _.get(state, 'cycoPage.cycoValidationErrors')
});

export const mapDispatchToProps = dispatch => ({
    onClickContinue() {
        dispatch(submit(CYCO_FORM_ID));
    },
    // handleSubmit will call this function when a form submit is triggered
    // formValues are passed by handleSubmit per api specification
    onFormSubmit(formValues, dispatch) {
        dispatch(spinnerOpen('base.processing'));
        dispatch(submitCycoApiAction(formValues));
        dispatch(trackTransition('pp_credit_cycopage', 'completeform_pp_credit_cycopage'));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: CYCO_FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true,
        validate,
        onSubmitFail
    })(CycoPageForm)
));
